import { useEffect, useRef, useState } from "react";
import { animate, motion, useInView } from "framer-motion";

function Counter({ to, suffix = "" }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const [val, setVal] = useState(0);

  useEffect(() => {
    if (!inView) return;
    const controls = animate(0, to, {
      duration: 2.2,
      ease: [0.22, 1, 0.36, 1],
      onUpdate: (v) => setVal(Math.round(v)),
    });
    return () => controls.stop();
  }, [inView, to]);

  return (
    <span ref={ref}>
      {val.toLocaleString("en-IN")}
      {suffix}
    </span>
  );
}

const STATS = [
  { value: 10, suffix: "+", label: "Years Experience" },
  { value: 5000, suffix: "+", label: "Tons Bought" },
  { value: 1000, suffix: "+", label: "Clients Served" },
  { static: "<60 min", label: "Response Time" },
];

export default function Stats() {
  return (
    <section data-testid="stats-section" className="bg-brand-dark text-white">
      <div className="mx-auto grid max-w-7xl grid-cols-2 lg:grid-cols-4 lg:divide-x lg:divide-white/10">
        {STATS.map((stat, i) => (
          <motion.div
            key={stat.label}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1], delay: i * 0.1 }}
            data-testid={`stat-${i}`}
            className="px-6 py-12 text-center md:py-16"
          >
            <p className="whitespace-nowrap font-display text-3xl font-extrabold tracking-tight text-white sm:text-5xl">
              {stat.static ? stat.static : <Counter to={stat.value} suffix={stat.suffix} />}
            </p>
            <p className="mt-2 text-sm text-white/65">{stat.label}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
